import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordsMatchValidation } from '../../../shared/validators/password-match.validator';
import { PasswordStrengthValidator } from '../../../shared/validators/password-strength.validator';
import { AuthenticationService } from '@flexyoo/auth';
import { LoggerService } from '@flexyoo/core';
import { catchError } from 'rxjs';
import { HttpErrorHandlerService } from '@flexyoo/shared/services';
import { GenericPageWithLogoComponent } from '@flexyoo/shared/ui';
import { TranslateModule } from '@ngx-translate/core';
import { MatError, MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

type IFormValue = {
  password: FormControl<string>;
  confirmPassword: FormControl<string>;
};

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  standalone: true,
  imports: [
    GenericPageWithLogoComponent,
    TranslateModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatError,
    MatInput,
    MatButton,
  ],
})
export class ForgotPasswordComponent implements OnInit {
  hash: string;
  name: string;

  private readonly logger = inject(LoggerService);
  protected readonly form = new FormGroup<IFormValue>(
    {
      password: new FormControl('', [Validators.required, PasswordStrengthValidator.validate]),
      confirmPassword: new FormControl('', Validators.required),
    },
    {
      validators: PasswordsMatchValidation.validate,
    }
  );

  constructor(
    private readonly authService: AuthenticationService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly httpErrorHandlerService: HttpErrorHandlerService
  ) {}

  ngOnInit() {
    this.hash = this.route.snapshot.queryParams.hash;
    this.name = this.route.snapshot.queryParams.name;
    if (!this.hash) {
      this.logger.error('No hash found');
      this.router.navigate(['/login']);
    }
  }

  onSubmit() {
    if (this.form.valid) {
      this.form.disable();

      const password = this.form.get('password').value;

      this.authService
        .confirmEmployeePassword({ Hash: this.hash, Password: password })
        .pipe(
          catchError((error) => {
            this.form.enable();
            return this.httpErrorHandlerService.handleError(error);
          })
        )
        .subscribe((x) => {
          if (x) {
            this.router.navigateByUrl('/login');
          }
        });
    }
  }
}
